import { notifications } from '@mantine/notifications';
import i18n from '@web/i18n';
import { ApiError } from './api';

/** Human-readable message for any thrown value. Server messages are already user-facing. */
export function errorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.code === 'RATE_LIMITED') return i18n.t('errors.rateLimited');
    if (error.code === 'INTERNAL') return i18n.t('errors.internal');
    return error.message;
  }
  if (error instanceof TypeError) return i18n.t('errors.network');
  return i18n.t('errors.internal');
}

export function notifyError(error: unknown, title?: string): void {
  notifications.show({ color: 'red', title: title ?? i18n.t('common.errorTitle'), message: errorMessage(error) });
}

export function notifySuccess(message: string): void {
  notifications.show({ color: 'green', message });
}
